import React from 'react'
import { WaoEmptyListPlaceholder } from 'components/Forms'
import CustomList from 'components/lists/CustomList'
import RasterlistListItem from 'components/list-items/RasterlistListItem'
import { RasterModel } from 'data/models/RasterModel'

interface Props {
  raster: RasterModel[]
  selectedRaster?: RasterModel[]
  handleSelect?: (raster: RasterModel) => void
  multiSelect?: boolean
}

const RasterList: React.FC<Props> = ({
  raster,
  selectedRaster = [],
  handleSelect,
  multiSelect = false,
}) => {
  if (!raster || raster.length === 0) {
    return <WaoEmptyListPlaceholder />
  }

  return (
    <CustomList ariaLabel="raster items">
      {raster.map((item) => (
        <RasterlistListItem
          key={item.Id}
          raster={item}
          multiSelect={multiSelect}
          selected={selectedRaster.includes(item)}
          handleSelect={handleSelect}
        />
      ))}
    </CustomList>
  )
}

export default RasterList
